import { GENRE_MOVIE } from "../actions/actionType";

const genreState = {
  getGenre: {},
};
function genreReducer(state = genreState, action) {
  switch (action.type) {
    case GENRE_MOVIE:
      return { ...state, getGenre: action.payload };
    default:
      return state;
  }
}

export default genreReducer;
